export default __webpack_public_path__ + "static/media/MetricsLandingPage.bd193696.webp";